export default __webpack_public_path__ + "static/hero-cyber-month-8c45aa811e1607b40a80a45977b402b8.webp";